import React from 'react';
import { Modal, Collapse } from "antd";
import { useTranslation } from "react-i18next";
import { CaretRightOutlined } from "@ant-design/icons";

// Optional: Minimal custom CSS for the Collapse to perfectly match your theme if Tailwind isn't enough
// You might not need this if the Tailwind classes below are sufficient for your setup.
const customCollapseStyle = {
    background: 'transparent',
    border: 'none',
};

export default function FAQ({ isOpen, setOpen }) {
    const { t } = useTranslation();

    function handleCancel() {
        setOpen(false);
    }

    // Define FAQ items here. 
    const faqItems = [
        { key: '1', q: t("faq.q1"), a: t("faq.a1") },
        { key: '2', q: t("faq.q2"), a: t("faq.a2") },
        { key: '3', q: t("faq.q3"), a: t("faq.a3") },
        { key: '4', q: t("faq.q4"), a: t("faq.a4") },
        { key: '5', q: t("faq.q5"), a: t("faq.a5") },
        { key: '6', q: t("faq.q6"), a: t("faq.a6") },
        { 
            key: '9', 
            q: t("faq.q9"), 
            // Special handling for Q9 which includes a link
            a: (
                <span>
                    {t("faq.a9")}{" "}
                    <a 
                        className="text-[#3982B0] font-semibold hover:underline" 
                        href="https://www.linkedin.com/company/civibot/about/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        CiviBOT LinkedIn Profile
                    </a>
                </span>
            ) 
        },
    ];

    return (
        <Modal
            open={isOpen}
            title={<div className="text-2xl font-bold text-gray-800 mb-4">{t("faq.title")}</div>}
            centered
            footer={null}
            onCancel={handleCancel}
            width={700} // Slightly wider for better readability
            className="faq-modal"
        >
            <div className="w-full max-h-[60vh] overflow-y-auto pr-2 custom-scrollbar">
                <Collapse
                    accordion
                    ghost // Removes default AntD gray borders/backgrounds for a cleaner look
                    expandIcon={({ isActive }) => (
                        <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ color: '#3982B0' }} />
                    )}
                    style={customCollapseStyle}
                >
                    {faqItems.map((item) => (
                        <Collapse.Panel
                            key={item.key}
                            header={
                                <span className="text-[16px] font-semibold text-gray-700">
                                    {item.q}
                                </span>
                            }
                            className="mb-3 bg-gray-50 rounded-xl border-0 shadow-sm hover:bg-gray-100 transition-colors duration-300"
                        >
                            <div className="text-gray-600 leading-relaxed text-[15px] px-2 pb-2 whitespace-pre-line">
                                {item.a}
                            </div>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </Modal>
    );
}